import { useRouter } from 'next/navigation';
import { RxCross2 } from 'react-icons/rx';
import { useLocale } from 'next-intl';

import useEnterKey from '@/app/[locale]/hook/useEnterKey';
import type { ELanguage } from '@/enums/language.enum';

type SearchBarProps = {
  isSearchActive: boolean;
  setIsSearchActive: React.Dispatch<React.SetStateAction<boolean>>;
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
};

const SearchBar = ({ isSearchActive, setIsSearchActive, searchTerm, setSearchTerm }: SearchBarProps) => {
  const router = useRouter();
  const locale: ELanguage = useLocale() as ELanguage;

  const handleSearch = () => {
    if (searchTerm.trim() === '') return;

    router.push(`/${locale}/shop?search=${encodeURIComponent(searchTerm)}`, { scroll: false });

    setSearchTerm('');
    setIsSearchActive(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearch();
    }
  };

  useEnterKey(handleSearch, isSearchActive);

  return (
    <>
      {isSearchActive && (
        <div className="absolute right-0 flex items-center gap-2">
          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            onKeyDown={handleKeyDown}
            className="relative w-[250px] rounded-[144px] border border-clr-df px-4 py-2 text-base font-medium text-clr-92 outline-none dark:border-slate-500 dark:bg-slate-800 2xl:w-[306px]"
          />
          <button
            onClick={() => setIsSearchActive(false)}
            className="absolute right-2 text-xl text-clr-bb transition-opacity duration-300 ease-in-out focus:outline-none dark:text-white"
          >
            <RxCross2 />
          </button>
        </div>
      )}
    </>
  );
};

export default SearchBar;
